export default __webpack_public_path__ + "static/media/sprout-tree-svgrepo-com.ba9e90fe.svg";